exports = module.exports = require("../../../../../node_modules/css-loader/lib/css-base.js")(false);
// imports


// module
exports.push([module.id, ".proTitle[data-v-f5c09b6a]{color:#ffffd8;font-weight:700;font-size:16px;text-align:center;background:#388e3c}", ""]);

// exports



//////////////////
// WEBPACK FOOTER
// ./node_modules/css-loader?minimize!./node_modules/vue-loader/lib/style-compiler?{"vue":true,"id":"data-v-f5c09b6a","scoped":true,"hasInlineConfig":false}!./node_modules/vue-loader/lib/selector.js?type=styles&index=0!./src/components/project_info/project_budget/prject_bud_details/insertForm.vue
// module id = 1174
// module chunks = 3